// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__jnizw","ripple":"styles_ripple__ZFsD0","shimmer":"styles_shimmer__N4Ly0"};